import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useSelector } from "react-redux";
import FallBackUI from "./FallBackUI";

const PaymentEnvironment = ({ children,setQuantityDarwerOpen,showFallback }) => {
  const paymentIntentData = useSelector(
    (state) => state?.subscription?.paymentIntentData
  );

  // Load Stripe with appropriate public key
  const stripePromise = loadStripe(
    process.env.NODE_ENV === "development"
      ? "pk_test_51Iyt1aIWA448nFWKdP01vg6idkCFTbeVygY8A74m1bs0tj8KLKPnDgXtLwGqFQfGYWHAU9ipgIMYAJ7jMtcgjkvz00ck9EHFeD"
      : "pk_live_51Iyt1aIWA448nFWKmt0rayRnYNu0H5iXqwnMbXOQj29v7GUgO3TjC9WvYIstPMUDmgGiMe1zRud5fB1mChyaSCXW00lI8GTZhK"
  );

  const clientSecret = paymentIntentData?.secret;

  if (!clientSecret&&showFallback) {
    // Handle the absence of a clientSecret (e.g., show a loader, error message, or fallback UI)
    return <FallBackUI setQuantityDarwerOpen={setQuantityDarwerOpen}/>;
  }

  const options = {
    // Passing the client secret obtained
    clientSecret,
    // Fully customizable with appearance API
    appearance: {
      /* Customize appearance here */
    },
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  );
};

export default PaymentEnvironment;
